<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                v-model="keyword"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                @input="search"
                @focus="showForm"
                @keyup.enter="redirectToSearch"
                :class="{
                    'c-form__input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen,
                }"
                ref="searchInput"
            />
        </div>

        <a
            v-if="!isFormVisible"
            :href="`/vyhladavanie${keyword ? `?search=${keyword}` : ''}`"
            class="c-btn c-btn--transparent"
            :class="{
                'is-loading': isLoading,
                'is-open': isOpen,
            }"
        >
            <i class="ico ico-search"></i>
        </a>

        <button
            v-else
            type="button"
            @click="hideForm"
            class="c-btn c-btn--close"
            :class="{
                'is-open': isOpen,
            }"
        >
            <i aria-hidden="true" class="ico ico-cross-thick txs-is-hidden"></i>
            <div class="sc-text txs-is-visible">{{ $t("Autocomplete.Header.cancel") }}</div>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "FrontendJsAssets/components/Autocomplete/Form/index.vue";
import client from "FrontendJsAssets/common/client";
import { CancelToken } from "axios";

export default {
    extends: RshopAutocompleteForm,
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true,
        },
    },
    methods: {
        showForm() {
            this.$emit("show-form");
        },
        hideForm() {
            this.$emit("hide-form");
        },
        redirectToSearch() {
            window.location.href = this.searchUrl;
        },
        search() {
            this.$emit("input", this.keyword);

            // if is input too short
            if (this.limit > this.keyword.length + 1) {
                return false;
            }

            // cancel request
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }

            this.cancelToken = CancelToken.source();

            this.isLoading = true;

            // request
            client
                .get(this.autocompleteUrl, {
                    params: {
                        limit: this.limit,
                        search: this.keyword,
                        category_id: this.categoryId,
                        group: window.Eshop.options.customer_group_id
                            ? window.Eshop.options.customer_group_id
                            : null,
                    },
                    cancelToken: this.cancelToken.token,
                    timeout: this.timeout,
                })
                .then((response) => {
                    this.$emit("searched", this.keyword, response.data);
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (!client.isCancel(error)) {
                        this.isLoading = false;
                    }
                });
        },
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${encodeURIComponent(this.keyword)}` : ""}`;
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            }
        },
    },
};
</script>
